<template>

    <div id="eliminacionMultiplePlanificacionAnualCharter">
        
        <Button
            :size="15"
            color="#dc3545"
            colorText="#ffffff"
            tooltip="Eiminación de múltiples planificaciones"
            icon="fas fa-times"
            round
            :width="35"
            class="mr-2"
            @click.native="openModal('modal')"
            traslate
            :inactive="checkPlanificacionAnual.length ? false : true"
        />

        <ui-modal ref="modal" size="normal" title="Eliminar puerto de destino" @close="ActionSetZindexModal(false)">

            <table class="table table-striped">
                <thead>
                    <th class="text-center">Región</th>
                    <th class="text-center">Total Anual</th>
                </thead>
                <tbody>
                    <tr v-for="(item, index_item) in checkPlanificacionAnual" :key="index_item">
                        <td class="text-center" v-text="item.data.data[0]"></td>
                        <td class="text-center" v-text="item.data.data_complementaria.total"></td>
                    </tr>
                </tbody>
            </table>

            <div class="d-flex justify-content-between">
                <Button
                    :size="25"
                    color="#898476"
                    colorText="#ffffff"
                    tooltip="Modificar planificación"
                    text="Cancelar"
                    :width="130"
                    :height="35"
                    class="mr-2"
                    @click.native="closeModal('modal')"
                />

                <Button
                    v-if="isSend"
                    :size="25"
                    color="#dc3545"
                    colorText="#ffffff"
                    tooltip="Eliminar puerto"
                    text="Eliminar"
                    :width="130"
                    :height="35"
                    class="mr-2"
                    inactive
                />

                <Button
                    v-else
                    :size="25"
                    color="#dc3545"
                    colorText="#ffffff"
                    tooltip="Eliminar puerto"
                    text="Eliminar"
                    :width="130"
                    :height="35"
                    class="mr-2"
                    @click.native="eliminar"
                />
            </div>

        </ui-modal>

    </div>
  
</template>

<script>

    // Vue
    import Vue from "vue";

    // Toast
    import VueToastify from "vue-toastify";
    Vue.use(VueToastify);
    
    import { mapActions, mapState } from 'vuex'

    // Keen UI
    import UiModal from "keen-ui/src/UiModal";

    import Button from '../../../common/Button.vue'
import { eliminarServiciosPorRutaPlanificacionAnualCharter } from '../../../../constants/charter';

    // API
    // import { eliminarPuertosPrincipales } from '../../../../constants/lineas';

    export default {
        // props : ['data'],
        components: { Button, UiModal },

        data() {
            return {
                data : [],
                isSend : false
            };
        },

        computed : {
            // ...mapState('lineas',['habilitarEdicionMultipleAnual','puertosSeleccionadosPlanAnual','checkPlanificacionAnual']),
            ...mapState('charter',['checkPlanificacionAnual']),
        },

        methods : {

            ...mapActions(['ActionSetZindexModal']),
            ...mapActions('charter',['actionSetDataPlanificacionAnualTabla']),

            openModal(ref) {
                this.$refs[ref].open();
                this.ActionSetZindexModal(true);
            },

            closeModal(ref) {
                this.$refs[ref].close();
            },

            async eliminar(){

                let data  = [];
                this.isSend = true;

                this.$vToastify.loader('Eliminando planificaciones');

                this.checkPlanificacionAnual.map( item => data.push({ 
                    "plan_id" : item.data.data_complementaria.annual_plan_id,
                    "route_id" : item.data.data_complementaria.route_id,
                }));

                const sql = await eliminarServiciosPorRutaPlanificacionAnualCharter({ "plans" : data });
                
                if (sql.code == 200) {
                    this.closeModal('modal');
                    this.actionSetDataPlanificacionAnualTabla();
                    this.$vToastify.stopLoader();
                    this.$vToastify.success( sql.message, "Proceso finalizado");
                    this.isSend = false;
                } else {
                    this.$vToastify.stopLoader();
                    this.$vToastify.error( sql.message, "Proceso finalizado");
                    this.isSend = false;

                }

            },

        },
    
    }
</script>


<style>

    #eliminacionMultiplePlanificacionAnualCharter .ui-modal__container {
        width: 70% !important;
        height: auto !important;
    }

</style>
